<template lang="pug">
    .md-content
        PmBreadcrumbs(:view="lenguageNavSelected.breadcrumb", :section="section", :lang="lenguage")
        PmBanner(:name="lenguageNavSelected.title", :image="banner")
        PmContentBox(:content="lenguageNavSelected.box")
        .container
            .row
                .col-md-4
                    PmSidebar(:options="lenguageNavSelected.nav", :contact="true", :lang="lenguage")
                .col-md-8
                    transition(name="fade", mode="out-in")
                        router-view(:lang="lenguage")

</template>

<script>
import PmBreadcrumbs from '@components/atoms/PmBreadCrumbs.vue'
import PmBanner from '@components/atoms/PmBanner.vue'
import PmContentBox from '@components/atoms/PmContentBox.vue'
import PmSidebar from '@components/atoms/PmSidebar.vue'

import productsBanner from '@img/products/Banner_PRODUCTS.jpg'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    components: {
        PmBreadcrumbs, PmBanner, PmContentBox, PmSidebar
    },
    mounted: function(){
        this.$data.section = this.$route.name;
        let to = this.moveToDown
        ? this.$refs.description.offsetTop - 60
        : 0

    window.scroll({
        top: to,
        left: 0,
        behavior: 'smooth'
    })

    this.moveToDown = !this.moveToDown
    },
    data: function(){
        return{
            lenguage: 'EN',

            enContent: {
                nav: [
                    {name:"Small Cells", path: "/en/products/small-cells"},
                    {name:"DAS", path: "/en/products/das"},
                    {name:"Optical Fiber", path: "/en/products/optical-fiber"},
                    {name:"Towers and Rooftops", path: "/en/products/towers-and-rooftops"}
                ],
                box: 'Our portfolio is designed to offer optimal locations, services, and scale to wireless, broadcast, WISP and IoT providers seeking to enhance their network coverage and capacity.',
                title: 'PRODUCTS',
                breadcrumb: {name:'Products', link:'/en/products/small-cells'},
            },
            esContent: {
                nav: [
                    {name:"Small Cells", path: "/es/productos/small-cells"},
                    {name:"DAS", path: "/es/productos/das"},
                    {name:"Fibra Óptica", path: "/es/productos/fibra-optica"},
                    {name:"Torres y Azoteas", path: "/es/productos/torres-y-azoteas"}
                ],
                box: 'Nuestro portafolio de productos está diseñado para ofrecer excelentes ubicaciones, servicios y escala a los operadores móviles, y a los proveedores de servicios de comunicaciones inalámbricas, radiodifusoras, WISPs e IoT que esperan mejorar su cobertura y su capacidad de red.',
                title: 'PRODUCTOS',
                breadcrumb: {name:'Productos', link:'/es/productos/small-cells'},
            },
            
            banner: productsBanner,
            
            section: ''
        }
    },
    computed: {
        lenguageNavSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.enContent : this.$data.esContent
        }
    },
}
</script>

<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/components/organisms/PmProducts.vue